import './index.scss';
const PrivacyPolicy = () => {
	return (
		<div className="privacyPolicy">
			<div className="content">
				<div className="title">Política de Privacidade Mourgames - Até 31/12/2024</div>
				<div className="textItem">
					<p>
						Bem-vindo(a) à Política de Privacidade da EstrelaBet! Nós levamos a proteção dos seus
						dados pessoais muito a sério e estamos comprometidos em manter sua privacidade ao
						utilizar nossos serviços. Essa Política de Privacidade se aplica a todas as atividades
						de tratamento de dados realizadas pela EstrelaBet e é válida para todos os nossos
						clientes, parceiros, prestadores e demais partes interessadas em relação às informações
						que compartilham conosco. Além disso, essa política é aplicável a quaisquer informações
						coletadas tanto online quanto offline.
					</p>

					<p>
						Ao aceitar esta Política de Privacidade ou os Termos e Condições Gerais da EstrelaBet,
						os controladores conjuntos dos seus dados pessoais serão: a) Stars Investments N.V., uma
						empresa registrada em Curaçao sob o número 158499, com endereço em Zuikertuintjeweg Z/N
						(Zuikertuin Tower), Curaçao, autorizada pelo Governo Geral de Curaçao através da
						solicitação OGL/2024/542/0424; e b) EB Intermediações e Jogos S.A., uma empresa
						constituída de acordo com as leis brasileiras, inscrita no CNPJ sob o número
						52.639.845/0001-25, com sede na Rua Geraldo Flausino Gomes, nº 78, 2º andar, Bairro
						Cidade Monções, São Paulo/SP, CEP 04.575-903. Essas empresas atuarão conjuntamente no
						processamento dos seus dados pessoais durante o período de transição estabelecido pela
						legislação brasileira, que se estende até 1º de janeiro de 2025. Após essa data, a EB
						Intermediações e Jogos S.A. passará a ser a única controladora dos dados, sujeito à
						autorização federal concedida pela Secretaria de Sorteios e Apostas do Ministério da
						Fazenda.
					</p>

					<p>
						Ao acessar e utilizar o site www.estrelabet.com (“Site” ou “Plataforma”) você declara
						que leu, compreendeu e concorda, de forma inequívoca, com os termos desta Política de
						Privacidade e seu Anexo I – Termo de Consentimento Para Transferência de Dados e
						Recursos.
					</p>

					<p>
						Nós entendemos a importância de proteger suas informações pessoais e queremos que você
						compreenda como coletamos, utilizamos e protegemos essas informações. Por isso, esta
						política foi escrita em linguagem clara e acessível, para que você possa compreender
						facilmente nossas práticas de privacidade.
					</p>

					<p>
						Quando você solicita, contrata ou utiliza os produtos e serviços da EstrelaBet,
						coletamos dados pessoais relacionados a você. Essa coleta começa no momento em que você
						interage conosco e pode ocorrer de forma direta, quando você fornece informações
						pessoais, ou de forma automática, quando você aceita cookies, por exemplo.
					</p>

					<p>
						Cookies são pequenos arquivos de texto que os sites da internet armazenam no seu
						navegador quando você os visita. Eles contêm informações como suas preferências de
						idioma, login, histórico de navegação e outras configurações, e são usados pelos sites
						para melhorar sua experiência de navegação.
					</p>

					<p>
						Você pode optar por desabilitar os cookies através das opções individuais do seu
						navegador. As informações mais detalhadas sobre o gerenciamento de cookies em
						navegadores específicos podem ser encontradas nos respectivos sites dos navegadores.
					</p>

					<p>
						Também podemos receber dados pessoais de parceiros contratados para finalidades
						específicas, como para aumentar nossa segurança contra fraudes, para cumprir obrigações
						legais e regulatórias aplicáveis, ou para melhorar sua experiência com a utilização de
						nossos serviços.
					</p>

					<p>
						Para utilizar nossos produtos e serviços, você deve concordar com esta Política de
						Privacidade, além de fornecer informações verdadeiras, atualizadas e precisas. É
						importante lembrar que você é o único responsável por informações falsas, desatualizadas
						ou imprecisas que nos fornecer diretamente. Ao aceitar esta Política de Privacidade ou
						os Termos e Condições Gerais da EstrelaBet, os controladores conjuntos dos seus dados
						pessoais serão: a) Stars Investments N.V., uma empresa registrada em Curaçao sob o
						número 158499, com endereço em Zuikertuintjeweg Z/N (Zuikertuin Tower), Curaçao,
						autorizada pelo Governo Geral de Curaçao através da solicitação OGL/2024/542/0424; e b)
						EB Intermediações e Jogos S.A., uma empresa constituída de acordo com as leis
						brasileiras, inscrita no CNPJ sob o número 52.639.845/0001-25, com sede na Rua Geraldo
						Flausino Gomes, nº 78, 2º andar, Bairro Cidade Monções, São Paulo/SP, CEP 04.575-903.
						Essas empresas atuarão conjuntamente no processamento dos seus dados pessoais durante o
						período de transição estabelecido pela legislação brasileira, que se estende até 1º de
						janeiro de 2025. Após essa data, a EB Intermediações e Jogos S.A. passará a ser a única
						controladora dos dados, sujeito à autorização federal concedida pela Secretaria de
						Sorteios e Apostas do Ministério da Fazenda.
					</p>

					<h3>1. QUAIS DADOS SÃO COLETADOS</h3>

					<p>Dados informados pelo titular:</p>

					<p>
						Coletamos os dados pessoais informados pelo titular por meio de seu cadastro em nossa
						plataforma com o objetivo de fornecer nossos serviços, melhorar a experiência do usuário
						e cumprir nossas obrigações contratuais, legais e regulatórias, além de utilizá-los para
						fins de marketing. Essa coleta é realizada de forma transparente e responsável,
						garantindo a privacidade e segurança dos dados dos usuários.
					</p>

					<p>Os dados coletados podem incluir:</p>

					<p>
						Dados cadastrais, tais como: nome, CPF, nacionalidade, endereço, data de nascimento;
					</p>

					<p>Dados de contato, tais como: telefone e e-mail;</p>

					<p>
						Outras informações a serem solicitadas em jornadas específicas, como durante a prestação
						de suporte ao usuário, mediante consentimento ou base legal aderente à solicitação
						realizada.
					</p>

					<p>
						Adicionalmente, poderemos solicitar documentos que comprovem a veracidade das
						informações prestadas.
					</p>

					<p>Dados coletados por meio de terceiros:</p>

					<p>
						Nos reservamos no direito de coletar dados adicionais obtidos em fontes públicas ou
						privadas, além das informações coletadas diretamente dos usuários, com o intuito de
						cumprimento de demandas regulatórias, prevenção a fraude, marketing e pesquisa. Essas
						informações podem ser obtidas em empresas de dados, parceiros de negócios, provedores de
						serviços ou outros parceiros. Essa coleta é realizada de forma transparente e
						responsável, garantindo a privacidade e segurança dos dados dos usuários.
					</p>

					<p>Os dados coletados podem incluir:</p>

					<ul>
						<li>
							Dados cadastrais, tais como: nome, CPF, nacionalidade, endereço, data de nascimento,
							gênero, entre outros;
						</li>
						<li>Informações socioeconômicas e de renda;</li>
						<li>Estado civil;</li>
						<li>Dados bancários, para depósitos e saques;</li>
						<li>Profissão;</li>
						<li>
							Outros dados necessários para prestação dos serviços contratados ou para atendimento
							de exigências legais ou regulatórias.
						</li>
					</ul>

					<p>
						Ressaltamos que os tratamentos de dados são realizados em conformidade com as leis de
						privacidade e proteção de dados aplicáveis.
					</p>

					<p>Dados de navegação e do dispositivo:</p>

					<p>
						Informamos que coletamos dados de navegação e do dispositivo utilizado pelo usuário com
						o objetivo de melhorar a sua experiência em nossa plataforma, bem como para fins
						estatísticos e de segurança.
					</p>

					<p>
						Os dados podem incluir informações sobre as páginas visitadas, tempo de navegação,
						localização geográfica, endereço IP, tipo de dispositivo, sistema operacional e
						navegador utilizado, entre outras informações relacionadas ao uso da plataforma. Essas
						informações são coletadas de forma automática por meio de tecnologias como cookies.
					</p>

					<p>Dados de utilização da plataforma:</p>

					<p>
						Informamos que armazenamos todas as operações realizadas pelo titular dos dados em nossa
						plataforma, tais como depósitos, saques, apostas, jogos, entre outros.
					</p>

					<h3>2. COMO A ESTRELABET USA OS SEUS DADOS:</h3>

					<p>
						Para prestar um serviço de alta qualidade e oferecer os melhores produtos, a EstrelaBet
						faz uso de seus dados pessoais. A seguir, apresentamos as finalidades para as quais
						utilizamos essas informações:
					</p>

					<ul>
						<li>Prestação dos serviços e oferecimento dos produtos contratados;</li>
						<li>
							Identificação, autenticação e verificação de requisitos para contratação dos serviços
							e produtos da EstrelaBet;
						</li>
						<li>Autenticação de transações financeiras;</li>
						<li>Atendimento de solicitações e dúvidas;</li>
						<li>Contato por telefone, e-mail, SMS, WhatsApp®, ou outros meios de comunicação;</li>
						<li>
							Aprimoramento dos serviços prestados pela EstrelaBet, inclusive com o cruzamento de
							informações sobre produtos contratados por pessoa física e por pessoa jurídica para
							oferecimento de novos produtos e serviços;
						</li>
						<li>
							Marketing, prospecção, pesquisa de mercado e de opinião para promover nossos produtos
							e serviços, bem como os de nossos parceiros. Essas atividades podem incluir a criação
							de ofertas, o envio de informações sobre produtos, serviços, novidades,
							funcionalidades, conteúdos, notícias e outros eventos relevantes para manter nosso
							relacionamento com você;
						</li>
						<li>Prevenção e resolução de problemas técnicos ou de segurança;</li>
						<li>
							Medidas de prevenção e combate a ilícitos, fraudes, crimes financeiros e garantia da
							segurança dos clientes da EstrelaBet e do sistema financeiro;
						</li>
						<li>
							Exercício regular de direitos da EstrelaBet, inclusive apresentando documentos em
							processos judiciais e administrativos, se necessário;
						</li>
						<li>
							Colaboração ou cumprimento de ordem judicial, de autoridade competente ou de órgão
							fiscalizador;
						</li>
						<li>Cumprimento de obrigação legal ou regulatória;</li>
						<li>
							Geração de estatísticas, estudos, pesquisas e levantamentos pertinentes às atividades
							e comportamento no uso dos produtos ou serviços.
						</li>
					</ul>

					<h3>3. ARMAZENAMENTO E COMPARTILHAMENTO DE DADOS PESSOAIS</h3>

					<p>
						Durante o período em que você for cliente da EstrelaBet e utilizar nossos produtos e
						serviços, seus dados pessoais serão mantidos em um ambiente seguro e controlado.
					</p>

					<p>
						Para a implementação de novos produtos ou serviços, a Stars Investments N. V. poderá
						realizar a portabilidade dos seus dados para outro fornecedor de serviço ou produto
						sempre observando as regras de armazenamento e compartilhamento de dados previstas nesta
						Política.
					</p>

					<p>
						Após o encerramento da conta na EstrelaBet, poderemos armazenar seus dados pessoais por
						um período adicional, se necessário, para fins de auditoria, cumprimento de obrigações
						legais ou regulatórias, exercício regular de direitos da EstrelaBet, ou por um prazo
						justificado por uma base legal que permita a retenção dos dados. Eventuais
						compartilhamentos de dados pessoais do usuário poderão ocorrer baseados em necessidade
						de cumprimento legal/regulatório, legítimo interesse da EstrelaBet e/ou consentimento do
						titular do dado, de acordo com o objetivo e a natureza do dado compartilhado.
					</p>

					<h3>4. DIREITO DOS TITULARES</h3>

					<p>
						O titular de dados pessoais possui o direito de solicitar à EstrelaBet, a qualquer
						momento, informações sobre os dados que a empresa possui e está tratando em relação a
						esse titular, tais como:
					</p>

					<ul>
						<li>Confirmação da existência de tratamento;</li>
						<li>Acesso aos dados;</li>
						<li>Correção de dados incompletos, inexatos ou desatualizados;</li>
						<li>
							Anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados
							em desconformidade;
						</li>
						<li>
							Portabilidade dos dados a outro fornecedor de serviço ou produto da Stars Investments
							N.V.;
						</li>
						<li>Eliminação dos dados pessoais tratados com o consentimento do titular;</li>
						<li>
							Informação sobre a possibilidade de não fornecer consentimento e sobre as
							consequências da negativa;
						</li>
						<li>Revogação do consentimento.</li>
					</ul>

					<p>
						Se você quiser exercer algum desses direitos, envie um e-mail para{' '}
						<a>service@mourgames.com</a>. No entanto, para garantir a segurança e evitar fraudes,
						podemos solicitar que você comprove sua identidade antes de processar sua solicitação.
					</p>

					<h3>5. TRANSFERÊNCIA INTERNACIONAL</h3>

					<p>
						A EstrelaBet é uma marca da empresa Stars Investments N.V., empresa licenciada em
						Curaçao. Nesse contexto, poderá haver transferências de alguns ou todos os dados de seus
						usuários para fora do território nacional.
					</p>

					<p>
						Essa transferência de dados pessoais é feita seguindo todas as exigências da legislação
						aplicável e adotando as melhores práticas de segurança e privacidade para proteger a
						integridade e a confidencialidade das informações dos usuários.
					</p>

					<h3>6. POLÍTICAS DE PRIVACIDADE DE TERCEIROS</h3>

					<p>
						A Política de Privacidade da EstrelaBet não se aplica a outros anunciantes ou sites.
						Assim, aconselhamos que consulte as respectivas Políticas de Privacidade desses
						servidores de anúncios de terceiros para obter informações mais detalhadas.
					</p>

					<h3>7. PROTEÇÃO À MENORES DE IDADE</h3>

					<p>
						A EstrelaBet não coleta intencionalmente quaisquer Informações Pessoais Identificáveis
						de pessoas menores de 18 anos. Se você acha que seu filho forneceu esse tipo de
						informações em nosso site, recomendamos que você entre em contato conosco imediatamente
						e faremos nossos melhores esforços para remover prontamente essas informações de nossos
						registros. A EstrelaBet ressalta que não tolera, recepciona, promove, incentiva ou
						fomenta o jogo de apostas esportivas ou qualquer jogo oferecido no site para menores de
						18 anos.
					</p>

					<h3>8. ALTERAÇÕES À POLÍTICA DE PRIVACIDADE</h3>

					<p>
						A EstrelaBet se reserva o direito de modificar esta Política de Privacidade a qualquer
						momento. Sempre que houver uma alteração significativa, as novas condições entrarão em
						vigor após serem divulgadas no nosso site ou enviadas por e-mail a você. Nós nos
						esforçamos para ser transparentes e, por isso, enviaremos um comunicado sempre que
						houver uma alteração relevante, indicando a nova versão vigente. Ao continuar a usar
						nossos produtos e serviços após uma alteração na Política de Privacidade, você confirma
						estar de acordo com as novas condições. No entanto, se você não concordar com as novas
						condições, poderá entrar em contato com nossos canais de atendimento para manifestar sua
						discordância.
					</p>

					<p>
						Caso tenha alguma dúvida ou sugestão, por favor, entre em contato conosco por meio do
						link <a href="https://www.mourgames.com/">https://www.mourgames.com</a>. Estamos sempre
						à disposição para ajudar e garantir a sua satisfação ao utilizar nossos serviços.
					</p>

					<p>
						<b>Política atualizada em 12/2024 </b>
					</p>

					<p>
						<b>Versão:2.4 </b>
					</p>

					<h1>Política de Privacidade - EstrelaBet - A partir de 01/01/2025</h1>

					<p>
						A EstrelaBet valoriza a sua privacidade e se compromete a proteger suas informações
						pessoais. Esta Política de Privacidade descreve quais dados são coletados durante a
						utilização dos serviços da EstrelaBet, as razões para essa coleta e como esses dados são
						utilizados.
					</p>

					<p>
						Esta Política de Privacidade constitui um acordo entre você e a EstrelaBet, integrando
						os Termos e Condições de Uso da nossa plataforma. Alterações podem ser realizadas
						periodicamente, e as atualizações serão publicadas no site oficial da EstrelaBet.
						Recomendamos que você revise este documento regularmente para estar sempre atualizado(a)
						sobre nossas práticas de privacidade.
					</p>

					<p>
						Ao acessar e utilizar o site www.estrelabet.bet.br (“Site” ou “Plataforma”) você declara
						que leu, compreendeu e concorda, de forma inequívoca, com os termos desta Política de
						Privacidade. Você também consente expressamente que a EstrelaBet poderá coletar,
						armazenar, processar, compartilhar, utilizar, divulgar ou tratar de qualquer outra forma
						as suas informações, incluindo dados pessoais, para as finalidades aqui descritas.
					</p>

					<p>
						O tratamento de dados realizado pela EstrelaBet é feito em conformidade com a legislação
						vigente, incluindo a Lei nº 13.709/2018 - Lei Geral de Proteção de Dados Pessoais
						(LGPD), e quaisquer outras normas aplicáveis, como a Lei nº 14.790/2023.
					</p>

					<h3>1. INFORMAÇÕES GERAIS</h3>

					<h4>1.1. O que é a LGPD?</h4>

					<p>
						A Lei Geral de Proteção de Dados (“LGPD”), Lei nº 13.709/2018, é uma legislação
						brasileira que define como Dados Pessoais devem ser tratados. A LGPD possui como
						objetivo proteger a privacidade, a liberdade e os direitos dos cidadãos, apresentando
						regras claras sobre a coleta, uso e segurança das informações tanto em meio físico como
						digital e é aplicável a pessoas naturais e jurídicas de direito público e privado.
					</p>

					<p>
						Visto isso, a EstrelaBet segue as exigências da LGPD e aplica as diretrizes da norma em
						todas as atividades que envolvem Dados Pessoais, adotando um tratamento responsável e
						transparente dessas informações.
					</p>

					<h4>1.2. O que são Dados Pessoais e Dados Pessoais Sensíveis?</h4>

					<p>
						Os Dados Pessoais são quaisquer informações que identificam ou podem identificar uma
						pessoa, como nome, endereço, e-mail, CPF, entre outros. Esses dados permitem reconhecer
						um indivíduo diretamente ou por meio da associação com outras informações.
					</p>

					<p>
						Já os Dados Pessoais sensíveis são uma categoria especial de Dados Pessoais que requer
						maior cuidado e incluem informações como origem racial ou étnica, convicção religiosa,
						opinião política, filiação a sindicato ou a organização de caráter religioso, filosófico
						ou político, dados referentes à saúde ou à vida sexual, e dados genéticos ou
						biométricos, quando vinculados a uma pessoa natural.
					</p>

					<p>
						Por sua natureza, esses dados demandam proteção adicional devido ao seu potencial de
						impacto sobre os direitos e liberdades dos titulares.
					</p>

					<h4>1.3. Quem é o Controlador de Dados Pessoais nos sites da EstrelaBet?</h4>

					<p>
						O Controlador de Dados é a pessoa natural ou jurídica, de direito público ou privado,
						que decide sobre o tratamento de Dados Pessoais. Em outras palavras, é o responsável por
						definir quais dados serão coletados, a finalidade dessa coleta, e de que forma as
						informações serão usadas e protegidas.
					</p>

					<p>
						No caso dos sites da EstrelaBet, a EB Intermediações e Jogos S.A., sociedade anônima
						fechada, inscrita no Cadastro Nacional da Pessoa Jurídica do Ministério da Economia
						(“CNPJ/ME”) sob o nº 52.639.845/0001-25, com sede na Rua Geraldo Flausino Gomes, nº 78,
						2º andar, Bairro Cidade Monções, São Paulo/SP, CEP 04.575-903, exerce a atuação como o
						controlador de dados, exercendo essa responsabilidade em conformidade com a legislação
						vigente.
					</p>

					<h4>1.4. Por que a EstrelaBet coleta seus Dados Pessoais?</h4>

					<p>
						A EstrelaBet coleta Dados Pessoais de seus usuários para atender às exigências legais e
						regulamentares indispensáveis ao funcionamento de suas atividades. Além disso, utiliza
						essas informações para oferecer uma experiência segura, personalizada e alinhada às
						necessidades de cada usuário.
					</p>

					<p>
						Visto isso, as Leis nº 13.756/2018 e nº 14.790/2023 e Portarias da Secretaria de Prêmios
						e Apostas do Ministério da Fazenda e do Ministério do Esporte que regulam o setor de
						apostas e jogos online no Brasil definem diretrizes que devem ser seguidas pelas
						empresas do ramo, como exemplo explicamos abaixo alguma das Portarias e obrigações que
						nos permitem coletar seus Dados Pessoais:
					</p>

					<h3>Portaria SPA/MF nº 722, de 2 de maio de 2024</h3>

					<p>
						Essa portaria estabelece requisitos técnicos que devem ser observados pelos operadores
						de apostas esportivas e jogos online, conforme previsto nas Leis nº 13.756/2018 e nº
						14.790/2023. Entre os principais pontos, destacam-se:
					</p>

					<ul>
						<li>
							<b>(a)</b> As atividades de supervisão e fiscalização dos sistemas de apostas são
							disciplinadas em regulamento específico da Secretaria de Prêmios e Apostas do
							Ministério da Fazenda. Deste modo, a EstrelaBet deve conceder pleno acesso aos seus
							sistemas para as unidades e agentes de fiscalização, assegurando transparência nas
							operações.
						</li>
						<li>
							<b>(b)</b> Com isso, a EstrelaBet deve encaminhar à Secretaria de Prêmios e Apostas os
							dados referentes às apostas, apostadores, carteiras dos apostadores, destinações
							legais e demais informações de suas operações, conforme periodicidade e formato
							estabelecidos no Manual SIGAP fornecido pelo Ministério da Fazenda e a Secretaria de
							Prêmios e Apostas.
						</li>
						<li>
							<b>(c)</b> Além disso, a EstrelaBet coleta os dados de cadastro do usuário para
							obedecer a mesma Portaria, que cita uma série de regras para o gerenciamento de contas
							dos apostadores pelo operador, ou seja, a EstrelaBet. Nesse sentido, a EstrelaBet
							deve, mas não se limita à:
							<ul>
								<li>
									<i>(i)</i> autenticar a entrada de qualquer apostador cadastrado no sistema por
									meio de usuário e senha ou por meio de biometria;
								</li>
								<li>
									<i>(ii)</i> caso alguma atividade suspeita seja detectada, como por exemplo
									múltiplas tentativas malsucedidas de acesso, a EstrelaBet deve verificar o porquê
									do ocorrido, consultando inclusive informações do usuário como Dados Pessoais e
									realizar o bloqueio da respectiva conta;
								</li>
								<li>
									<i>(iii)</i> a EstrelaBet ainda deve implementar corretamente quaisquer limitações
									e exclusões estabelecidas pelo apostador, pelo agente operador e pela Secretaria
									de Prêmios e Apostas do Ministério da Fazenda.
								</li>
							</ul>
						</li>
					</ul>

					<h3>Portaria SPA/MF nº 1.231, de 31 de julho de 2024</h3>

					<ul>
						<li>
							<b>(a)</b> A EstrelaBet deve estruturar seu sistema de apostas de forma a promover
							práticas de jogo responsável e prevenir transtornos associados ao jogo, como
							dependência e comportamentos compulsivos e como parte disso, a EstrelaBet em todas as
							ações de publicidade, marketing e os próprios canais de apostas respeitem normas de
							proteção aos usuários, incluindo a proibição de acesso por menores de idade.
						</li>
						<li>
							<b>(b)</b> Assim, para proteger o bem-estar dos usuários, a EstrelaBet coleta Dados
							Pessoais, como identidade e informações de contato, para garantir a verificação segura
							de cada apostador e autenticar acessos. Com base nisso, a plataforma utiliza esses
							dados para impedir o uso de contas por menores de idade e detectar atividades
							irregulares, cumprindo assim o requisito de prevenção a comportamentos compulsivos e
							de acesso inadequado.
						</li>
						<li>
							<b>(c)</b> A Portaria exige que a EstrelaBet informe seus apostadores sobre os riscos
							de dependência e transtornos associados ao jogo e para isso, a coleta de dados permite
							que a EstrelaBet personalize comunicações de conscientização sobre jogo responsável e
							ofereça campanhas educativas direcionadas. Dados Pessoais também são usados para
							contatar apostadores com alertas e orientações, promovendo uma comunicação ativa e
							contínua sobre práticas seguras de jogo.
						</li>
					</ul>

					<p>
						A título exemplificativo, essas são somente algumas das obrigações que a EstrelaBet
						segue e que nos permitem a coleta dos seus Dados Pessoais, no entanto, é possível
						verificar no tópico abaixo, quais Dados Pessoais a EstrelaBet coleta.
					</p>

					<h4>1.5. Quais Dados Pessoais a EstrelaBet coleta?</h4>

					<p>
						Abaixo, apresentamos uma tabela que detalha os tipos de Dados Pessoais coletados pela
						EstrelaBet, e finalidades.
					</p>

					<div>
						<table>
							<thead>
								<tr>
									<th>Finalidade do Processamento de Dados</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Cadastro de conta</td>
								</tr>
								<tr>
									<td>Verificação de identidade e informações de contato</td>
								</tr>
								<tr>
									<td>Gestão de Transações em sua conta</td>
								</tr>
								<tr>
									<td>Verificação da localização</td>
								</tr>
								<tr>
									<td>Monitoramento e avaliação de comportamento para prevenção de crimes</td>
								</tr>
								<tr>
									<td>
										Monitoramento e avaliação do comportamento do jogo para o desenvolvimento de
										negócios
									</td>
								</tr>
								<tr>
									<td>
										Monitoramento e avaliação do comportamento do jogo para ofertas personalizadas,
										bônus e interface do usuário
									</td>
								</tr>
								<tr>
									<td>Comunicações informativas e campanhas</td>
								</tr>
								<tr>
									<td>Consultas, reclamações e resolução de problemas</td>
								</tr>
								<tr>
									<td>Relatórios para autoridades regulatórias/legais</td>
								</tr>
								<tr>
									<td>Promoções e ofertas</td>
								</tr>
								<tr>
									<td>
										Garantia de qualidade e treinamento da equipe por meio de gravação de chamadas
										e/ou apresentação de material educativo
									</td>
								</tr>
								<tr>
									<td>
										Monitorar os padrões de jogo e identificar possíveis situações de alto risco de
										dependência/ compartilhar seus dados pessoais com bancos de dados nacionais de
										autoexclusão/exclusão
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div>
						<table>
							<thead>
								<tr>
									<th>Dados Pessoais Tratados</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										Dados de identificação pessoal; detalhes de contato (incluindo de telefone
										celular); dados fiscais; dados de previdência social; informações financeiras;
										informações de conexão; informações de localização
									</td>
								</tr>
								<tr>
									<td>
										Dados de identificação pessoal; informações financeiras; dados de previdência
										social; informações de conexão; informações de localização; foto, documentos de
										identificação (ex.: carteira de identidade, carteira de motorista)
									</td>
								</tr>
								<tr>
									<td>Dados de identificação pessoal; Informações Financeiras</td>
								</tr>
								<tr>
									<td>
										Localização física; informações de geolocalização; informações de dispositivo e
										conexão; GPS; endereço IP; GSM; raio do nível de confiança da posição
									</td>
								</tr>
								<tr>
									<td>
										Dados de identificação pessoal; detalhes de contato (incluindo de telefone
										celular); atividade de jogos; dados fiscais; dados de previdência social;
										informações financeiras
									</td>
								</tr>
								<tr>
									<td>
										Dados de identificação pessoal; atividade de jogos; informações financeiras;
										dados de previdência social; informações de conexão; informações de localização
									</td>
								</tr>
								<tr>
									<td>
										Dados de identificação pessoal; atividade de jogos; informações financeiras;
										dados de previdência social; informações de conexão; informações de localização
									</td>
								</tr>
								<tr>
									<td>Dados de identificação pessoal; detalhes de contato</td>
								</tr>
								<tr>
									<td>
										Dados de identificação pessoal; detalhes de contato; atividade de jogo;
										informações de conexão; informações de localização; informações financeiras
									</td>
								</tr>
								<tr>
									<td>
										Dados de identificação pessoal; atividade de jogos; informações financeiras;
										informações de previdência social; informações de conexão; informações de
										localização; informações fiscais
									</td>
								</tr>
								<tr>
									<td>Dados de identificação pessoal; detalhes de contato</td>
								</tr>
								<tr>
									<td>
										Dados de identificação pessoal; Detalhes de contato (incluindo telefone
										celular); Atividade de jogo
									</td>
								</tr>
								<tr>
									<td>
										Dados de identificação, mensagens/dados de comunicação (inclusive registros de
										apoio ao cliente); comportamento de jogo (atividade de apostas), comportamento
										transacional (dados financeiros e de pagamentos), dados de localização
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div>
						<table>
							<thead>
								<tr>
									<th>Base Legal para Tratamento de Dados</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										Execução do contrato e exercício regular dos direitos em processos judiciais ou
										administrativos
									</td>
								</tr>
								<tr>
									<td>
										Obrigações regulamentares/legais e exercício regular de direitos em processos
										judiciais ou administrativos
									</td>
								</tr>
								<tr>
									<td>
										Obrigações regulatórias/legais e exercício regular de direitos em processos
										judiciais ou administrativos
									</td>
								</tr>
								<tr>
									<td>Obrigações Regulamentares / Legais</td>
								</tr>
								<tr>
									<td>
										Obrigações regulamentares/legais e exercício regular de direitos em processos
										judiciais ou administrativos
									</td>
								</tr>
								<tr>
									<td>Interesse legítimo (relatórios internos e desenvolvimento de negócios)</td>
								</tr>
								<tr>
									<td>Interesse legítimo (experiência ideal para nossos clientes)</td>
								</tr>
								<tr>
									<td>Consentimento</td>
								</tr>
								<tr>
									<td>
										Interesse legítimo (experiência ideal para nossos clientes e solução de
										problemas) e/ou Obrigações regulatórias/legais por caso
									</td>
								</tr>
								<tr>
									<td>Obrigações regulatórias/legais</td>
								</tr>
								<tr>
									<td>Consentimento</td>
								</tr>
								<tr>
									<td>
										Interesse legítimo (experiência ideal para nossos clientes e garantia de
										qualidade de nossos serviços ao cliente)
									</td>
								</tr>
								<tr>
									<td>Obrigações regulatórias/legais</td>
								</tr>
							</tbody>
						</table>
					</div>

					<p>
						Caso tenha dúvidas sobre a coleta de dados ou qualquer tratamento realizado com seus
						dados pessoais, o titular pode exercer seus direitos diretamente com a EstrelaBet. Para
						mais informações, consulte o Item 1.8 desta política.
					</p>

					<h3>1.6. De quais terceiros a EstrelaBet obtém Dados Pessoais?</h3>

					<p>
						Na maioria dos casos, a EstrelaBet coleta os Dados Pessoais diretamente dos usuários. No
						entanto, em situações específicas e quando permitido pela legislação aplicável, a
						EstrelaBet também obtém Dados Pessoais de terceiros.
					</p>

					<p>
						Os dados de terceiros são tratados conforme a LGPD e esta Política de Privacidade e
						respeitam todas as restrições impostas por esses fornecedores, além dos requisitos da
						legislação nacional, garantindo transparência e segurança no uso das informações.
					</p>

					<p>A EstrelaBet pode obter Dados Pessoais de terceiros nas seguintes situações:</p>

					<ul>
						<li>
							<b>(a)</b> A EstrelaBet pode compartilhar e obter dados de outras empresas do mesmo
							grupo econômico. Qualquer transferência internacional de dados realizada pela
							EstrelaBet está em conformidade com as diretrizes da LGPD e as recomendações da
							Autoridade Nacional de Proteção de Dados (“ANPD”), incluindo a Resolução CD/ANPD nº
							19, de 23 de agosto de 2024.
						</li>
						<li>
							<b>(b)</b> Durante transações ou em parcerias, a EstrelaBet pode obter Dados Pessoais,
							sempre garantindo que exista uma justificativa legal para tal compartilhamento e uso.
						</li>
						<li>
							<b>(c)</b> Em determinados casos, terceiros compartilham Dados Pessoais com a
							EstrelaBet mediante autorização explícita do usuário. Um exemplo seria o uso de
							serviços de pagamento de terceiros: se o usuário optar por realizar transações por
							meio de provedores de pagamento, pode haver a autorização para que essas plataformas
							compartilhem com a EstrelaBet informações relevantes para confirmar e processar a
							transação de forma segura, como dados financeiros limitados e verificação de
							identidade.
						</li>
						<li>
							<b>(d)</b> Para atender a exigências legais e regulatórias, a EstrelaBet pode obter
							Dados Pessoais de fontes terceiras, como para verificação de identidade, prevenção à
							fraude e combate ao financiamento de atividades ilegais, prevenção a transtornos de
							jogo patológico, para não permissão de criação de conta e jogos por menores de 18
							anos, e outras razões, mas sempre dentro das normas vigentes.
						</li>
					</ul>

					<p>
						Ademais, para mais informações sobre a transferência internacional de dados e o
						armazenamento seguro dessas informações, consulte o Item 3 desta Política de
						Privacidade.
					</p>

					<h3>1.7. Com quais terceiros a EstrelaBet compartilha Dados Pessoais?</h3>

					<p>
						A EstrelaBet compartilha Dados Pessoais dos usuários com terceiros cuidadosamente
						selecionados, sempre que necessário para a prestação de serviços, atendimento a
						exigências regulatórias, e aprimoramento da experiência dos usuários na plataforma.
					</p>

					<p>
						Os terceiros seguem os mesmos padrões de segurança e confidencialidade adotados pela
						EstrelaBet. Abaixo, detalhamos as categorias de terceiros com os quais a EstrelaBet
						compartilha Dados Pessoais:
					</p>

					<ul>
						<li>
							<b>(a)</b> A EstrelaBet pode compartilhar dados com empresas do mesmo grupo, para
							permitir que suas operações estejam sempre adequadas e consigam proporcionar uma
							experiência segura e personalizada aos usuários.
						</li>
						<li>
							<b>(b)</b> Para manter suas operações, a EstrelaBet utiliza serviços de empresas
							especializadas em:
							<ul>
								<li>
									<i>(i)</i> provedores que oferecem suporte técnico e infraestrutura para operação
									e segurança da plataforma;
								</li>
								<li>
									<i>(ii)</i> empresas responsáveis por enviar e-mails e materiais promocionais aos
									usuários;
								</li>
								<li>
									<i>(iii)</i> consultores externos que assistem a EstrelaBet em assuntos como
									conformidade legal e fiscal;
								</li>
								<li>
									<i>(iv)</i> processadores de pagamento que garantem segurança nas transações
									financeiras da plataforma;
								</li>
								<li>
									<i>(v)</i> demais plataformas e empresas que permitem a EstrelaBet operacionalizar
									da forma adequada.
								</li>
							</ul>
						</li>
						<li>
							<b>(c)</b> A EstrelaBet trabalha com provedores que fornecem jogos e software de
							entretenimento, permitindo que os usuários acessem uma variedade de opções de apostas
							e jogos na plataforma. Os provedores recebem apenas os dados necessários para
							habilitar e personalizar a experiência de jogo.
						</li>
						<li>
							<b>(d)</b> Para desenvolver campanhas personalizadas e estratégias como marketing e
							remarketing, a EstrelaBet pode compartilhar dados com plataformas parceiras de
							marketing e publicidade para operacionar todo fluxo e procedimento relacionados a
							experiência do usuário, branding e growth.
						</li>
						<li>
							<b>(e)</b> Quando requerido por lei, a EstrelaBet compartilha Dados Pessoais com
							autoridades e órgãos reguladores, como a Secretaria de Prêmios e Apostas do Ministério
							da Fazenda, para cumprir obrigações regulatórias e garantir a segurança dos usuários.
						</li>
						<li>
							<b>(f)</b> Autoridades policiais, reguladoras e outras autoridades competentes para
							fins de investigação, cumprimento de exigências legais ou regulatórias;
						</li>
						<li>
							<b>(g)</b> Agências de prevenção de fraudes para a segurança dos usuários e da
							plataforma, prevenindo incidentes de segurança e detectando fraudes;
						</li>
						<li>
							<b>(h)</b> Órgãos governamentais para a integridade das operações esportivas e a
							conformidade com regulamentos;
						</li>
						<li>
							<b>(i)</b> Organizações que divulgam informações à EstrelaBet em conformidade com os
							termos acordados para tratamento de dados;
						</li>
						<li>
							<b>(j)</b> Terceiros necessários ao fornecimento de produtos ou serviços que a
							EstrelaBet tenha solicitado, como meio para a execução eficaz das atividades de
							prestação de serviço.
						</li>
					</ul>

					<p>
						É importante ressaltar que a EstrelaBet verifica que todos os terceiros envolvidos no
						tratamento de Dados Pessoais mantenham padrões de segurança e confidencialidade, em
						conformidade com a LGPD, e em todo processo de contratação e parceria, uma vez que
						realiza processos de due diligence e verificação de empresas.
					</p>

					<h3>1.8. Por quanto tempo a EstrelaBet irá armazenar seus Dados Pessoais?</h3>

					<p>
						A EstrelaBet armazena os Dados Pessoais dos usuários pelo tempo necessário para cumprir
						as finalidades específicas e as obrigações legais ou regulatórias. O período de
						armazenamento varia de acordo com as diferentes finalidades e requisitos legais
						aplicáveis.
					</p>

					<p>
						Abaixo estão os critérios que determinam o tempo de armazenamento dos Dados Pessoais:
					</p>

					<ul>
						<li>
							<b>(a)</b> A EstrelaBet mantém os Dados Pessoais enquanto for necessário para fornecer
							serviços ao usuário, incluindo o uso contínuo do site e suas funcionalidades;
						</li>
						<li>
							<b>(b)</b> Se o uso dos Dados Pessoais estiver fundamentado em um interesse legítimo
							da EstrelaBet, o armazenamento ocorre até que o usuário manifeste sua oposição a esse
							uso, desde que não existam outras obrigações que justifiquem sua manutenção;
						</li>
						<li>
							<b>(c)</b> Quando o tratamento de Dados Pessoais ocorre com base no consentimento do
							usuário, a EstrelaBet manterá os dados até que o usuário revogue esse consentimento;
						</li>
						<li>
							<b>(d)</b> A EstrelaBet retém Dados Pessoais pelo tempo exigido por lei ou regulamento
							aplicável, ou até o fim de um período de retenção necessário para defesa de direitos
							em ações judiciais, administrativas ou arbitrais;
						</li>
						<li>
							<b>(e)</b> Até a verificação de que a finalidade foi alcançada ou de que os dados
							deixaram de ser necessários ou pertinentes ao alcance da finalidade específica
							almejada;
						</li>
						<li>
							<b>(f)</b> Fim do período de tratamento;
						</li>
						<li>
							<b>(g)</b> Determinação da ANPD.
						</li>
					</ul>

					<p>
						Durante todo o período de armazenamento, a EstrelaBet adota medidas de segurança para
						proteger os Dados Pessoais, para permitir a integridade e confidencialidade das
						informações, em conformidade com a legislação vigente.
					</p>

					<p>
						Ainda, após o término do período de armazenamento, os Dados Pessoais poderão ser
						conservados para as seguintes finalidades: (i) cumprimento de obrigação legal ou
						regulatória pela EstrelaBet; (ii) transferência a terceiro, respeitando-se os requisitos
						de tratamento de Dados Pessoais dispostos na LGPD; e, (iii) uso exclusivo da EstrelaBet,
						sendo vedado o acesso à terceiros, e desde que anonimizados os Dados Pessoais.
					</p>

					<h3>
						1.9. Como a EstrelaBet verifica solicitações para exercer direitos dos Titulares de
						Dados Pessoais?
					</h3>

					<p>
						Os titulares de dados, ou seja, toda pessoa física a quem se refere tais Dados Pessoais,
						possuem o direito de solicitar à EstrelaBet, a qualquer momento, informações sobre os
						dados que a EstrelaBet está tratando, conforme descrito no artigo 18º da LGPD:
					</p>

					<ul>
						<li>Confirmação da existência de tratamento;</li>
						<li>Acesso aos dados;</li>
						<li>Correção de dados incompletos, inexatos ou desatualizados;</li>
						<li>
							Anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados
							em desconformidade;
						</li>
						<li>
							Portabilidade dos dados a outro fornecedor, mediante requisição expressa, de acordo
							com a regulamentação da autoridade nacional, observados os segredos comercial e
							industrial;
						</li>
						<li>Eliminação dos Dados Pessoais tratados com consentimento do titular;</li>
						<li>
							Informação sobre a possibilidade de não fornecer consentimento e sobre as
							consequências da negativa;
						</li>
						<li>
							Informação com as quais a EstrelaBet realizou o uso ou compartilhou Dados Pessoais;
						</li>
						<li>Revogação do consentimento.</li>
					</ul>

					<p>
						Para exercer quaisquer um desses direitos, você pode entrar em contato com o e-mail{' '}
						<a>service@mourgames.com</a>.
					</p>

					<p>
						As requisições serão avaliadas e respondidas tanto em relação ao andamento quanto ao
						resultado da solicitação, o mais breve possível, nos seguintes termos:
					</p>

					<ul>
						<li>
							<b>Solicitações de confirmação de existência ou acesso aos dados pessoais:</b> a
							resposta será fornecida de forma simplificada e imediata, ou por meio de uma
							declaração completa, detalhando a origem dos dados, a finalidade do tratamento, os
							critérios utilizados e, quando aplicável, a inexistência de registro. A resposta será
							disponibilizada em até 15 (quinze) dias, conforme o artigo 19, caput e incisos I e II
							da LGPD, respeitando os segredos comercial e industrial.
						</li>
						<li>
							<b>Outras solicitações:</b> para pedidos relacionados a outros direitos dos titulares,
							a EstrelaBet enviará a resposta ao e-mail fornecido pelo titular no prazo de até 15
							(quinze) dias. Em casos de solicitações mais complexas, o prazo para resposta poderá
							se estender até 30 (trinta) dias.
						</li>
					</ul>

					<p>
						Observe, porém, que a EstrelaBet só excluirá os Dados Pessoais se não houver obrigação
						legal ou direito legítimo que justifique sua retenção. Caso o usuário solicite a
						exclusão de seus Dados Pessoais, isso poderá limitar ou inviabilizar o uso de certos
						serviços que dependem desses dados, uma vez que a EstrelaBet não poderá mais
						processá-los para fins de acesso e funcionalidade desses serviços.
					</p>

					<h3>2. DADOS DE MENORES DE IDADE</h3>

					<p>
						A EstrelaBet não coleta quaisquer Dados Pessoais de pessoas menores de 18 anos. Além
						disso, cabe enfatizar que a EstrelaBet ressalta que não tolera, recepciona, promove,
						incentiva ou fomenta o jogo de apostas esportivas ou qualquer jogo oferecido no site
						para menores de 18 anos.
					</p>

					<p>
						Para maiores detalhamentos sobre o compromisso da EstrelaBet quanto ao tema de Jogo
						Responsável, vide a Política de Jogo Responsável.
					</p>

					<h3>3. TRANSFERÊNCIA INTERNACIONAL DE DADOS</h3>

					<p>
						É importante destacar que é possível que, em algum determinado momento, haja
						transferências de dados para fora do território nacional.
					</p>

					<p>
						A EstrelaBet realiza a transferência internacional de Dados Pessoais para apoiar
						operações e atividades de compartilhamento com finalidades operacionais específicas. As
						transferências ocorrem em conformidade com as regulamentações de proteção de dados e a
						Resolução CD/ANPD nº 19, de 23 de agosto de 2024, da ANPD.
					</p>

					<h4>a) Forma, duração e finalidade específica da transferência internacional:</h4>

					<p>
						As transferências internacionais realizadas pela EstrelaBet têm como finalidade o
						suporte operacional e compartilhamento de informações, para garantir a eficiência de
						diversos processos de comunicação, análise de dados e suporte ao cliente. Exemplos
						dessas operações incluem:
					</p>

					<ul>
						<li>
							Transferência de dados para operadores de sistemas de comunicação, a fim de viabilizar
							o envio de mensagens e atualizações para os usuários.
						</li>
						<li>
							Compartilhamento de dados com plataformas de tecnologia, permitindo o armazenamento de
							dados em servidores.
						</li>
						<li>
							Compartilhamento de dados com plataformas de telefonia, permitindo o envio de
							notificações aos jogadores inativos, visando a reativação de contas.
						</li>
						<li>
							Envio ocasional de dados anonimizados para consultorias especializadas, com o objetivo
							de realizar modelagem e análise de dados, assegurando que nenhum dado pessoal seja
							identificado.
						</li>
						<li>
							Compartilhamento de dados com fornecedores de tecnologia para desenvolver e otimizar
							modelos de identificação de jogadores, ajustados conforme metodologias específicas.
						</li>
						<li>
							Transferência de dados para equipes de consultoria externas em projetos específicos
							que exigem análise ampla e integrada de diversas áreas operacionais.
						</li>
						<li>
							Transferência de dados para provedores de jogos de apostas esportivas e cassino, a fim
							de possibilitar a execução e manutenção dos jogos dentro da plataforma, atendendo a
							requisitos técnicos e de operação contínua.
						</li>
					</ul>

					<p>
						A duração da transferência internacional de dados é fundamentada no cronograma de
						projetos da EstrelaBet, de modo que a transferência internacional de dados cessa ao
						tempo em que a finalidade do projeto se extingue, ou é mantida para fins de cumprimento
						de obrigação legal pela EstrelaBet perante à órgãos regulamentadores, como o Ministério
						Fazenda/Secretaria de Prêmios e Apostas.
					</p>

					<h4>b) País de destino dos dados transferidos:</h4>

					<p>
						Os Dados Pessoais são transferidos para os seguintes países, onde os fornecedores e
						parceiros operacionais mantêm suas operações:
					</p>

					<ul>
						<li>Estados Unidos da América</li>
						<li>Outros países, de acordo com o cronograma de projetos da EstrelaBet.</li>
					</ul>

					<h4>c) Identificação e contatos da EstrelaBet:</h4>

					<p>
						A Parte Designada responsável pela transferência é a EstrelaBet, e está disponível para
						contato por meio de <a>service@mourgames.com</a>.
					</p>

					<h4>d) Uso compartilhado de dados e finalidade:</h4>

					<p>
						Os Dados Pessoais são compartilhados entre as partes envolvidas estritamente para fins
						operacionais da plataforma, como a comunicação com usuários, análise de dados e
						atendimento ao cliente e outras conforme especificado no item a. deste tópico,
						assegurando que as finalidades e usos respeitem as diretrizes da LGPD.
					</p>

					<h4>e) Responsabilidades dos agentes que realizarão o tratamento:</h4>

					<p>
						Os agentes que realizam o tratamento de Dados Pessoais no contexto das transferências
						internacionais se comprometem a seguir rigorosamente as obrigações previstas pela
						legislação nacional e pelas disposições deste acordo, assegurando a conformidade e a
						proteção dos Dados Pessoais em todas as operações. As responsabilidades incluem:
					</p>

					<ul>
						<li>
							Utilização dos dados apenas para as finalidades específicas, sem possibilitar qualquer
							tratamento posterior que seja incompatível com essas finalidades, observando sempre as
							limitações, garantias e salvaguardas estabelecidas;
						</li>
						<li>
							Compatibilidade do tratamento com as finalidades informadas ao Titular, respeitando o
							contexto e propósito inicial do tratamento de dados;
						</li>
						<li>
							Limitação do tratamento ao mínimo necessário para alcançar as finalidades, garantindo
							que o escopo seja pertinente, proporcional e não excessivo em relação ao objetivo do
							tratamento de Dados Pessoais;
						</li>
						<li>
							Garantia de transparência e acessibilidade para os Titulares sobre: informações
							claras, precisas e de fácil acesso sobre o tratamento e os agentes envolvidos,
							respeitando os segredos comerciais e industriais;
						</li>
						<li>
							Consulta facilitada e gratuita sobre o tipo, duração e integralidade do tratamento de
							seus dados;
						</li>
						<li>
							Atualização e precisão dos Dados Pessoais, mantendo-os claros e relevantes para o
							cumprimento das finalidades estabelecidas;
						</li>
						<li>
							Adoção de medidas de segurança apropriadas e proporcionais aos riscos envolvidos na
							Transferência Internacional de Dados, protegendo contra acessos não autorizados, uso
							indevido, perda e outras ameaças;
						</li>
						<li>
							Prevenção de qualquer tratamento discriminatório, ilícito ou abusivo dos Dados
							Pessoais, assegurando um tratamento ético e respeitoso dos dados;
						</li>
						<li>
							Supervisão e controle sobre o tratamento realizado por qualquer pessoa que atue sob
							sua autoridade, garantindo que subcontratados ou colaboradores, remunerados ou não,
							realizem o tratamento em conformidade com as instruções e os requisitos estabelecidos
							na LGPD e legislações aplicáveis ao país, e em consonância com a LGPD;
						</li>
						<li>
							Manutenção de registros detalhados das operações de tratamento realizadas no contexto
							da transferência internacional de dados, assegurando a disponibilidade dessa
							documentação para apresentação à ANPD, sempre que solicitado.
						</li>
					</ul>

					<h4>f) Direitos do Titular e meios para seu exercício:</h4>

					<p>
						O Titular dos dados possui o direito de acessar, corrigir, restringir ou solicitar a
						exclusão de seus Dados Pessoais, e outros direitos previstos na LGPD. Para exercer seus
						direitos, o Titular pode entrar em contato pelo canal <a>service@mourgames.com</a>. O
						Titular também tem o direito de peticionar contra a EstrelaBet junto à ANPD.
					</p>

					<h4>g) Transferências posteriores:</h4>

					<p>
						Qualquer transferência posterior de Dados Pessoais será realizada somente para parceiros
						devidamente autorizados e apenas para finalidades específicas e definidas, assegurando
						que os Dados Pessoais permaneçam protegidos durante todo o processo.
					</p>

					<p>
						Além disso, o Titular dos Dados Pessoais possui o direito de obter da EstrelaBet,
						informações e ações em relação aos Dados Pessoais transferidos internacionalmente,
						conforme previsto na LGPD e no tópico 1.9 desta Política de Privacidade e abaixo.
					</p>

					<p>A qualquer momento e mediante requisição, o Titular poderá solicitar:</p>

					<ul>
						<li>Confirmação da existência de tratamento dos Dados Pessoais;</li>
						<li>Acesso aos Dados Pessoais objeto de tratamento;</li>
						<li>Correção de dados incompletos, inexatos ou desatualizados;</li>
						<li>
							Anonimização, bloqueio ou eliminação de dados considerados desnecessários, excessivos
							ou tratados em desconformidade com esta Política e a legislação nacional;
						</li>
						<li>
							Portabilidade dos dados para outro fornecedor de serviço ou produto, mediante
							requisição expressa e de acordo com a regulamentação da ANPD, respeitando segredos
							comerciais e industriais;
						</li>
						<li>
							Eliminação dos Dados Pessoais tratados com o consentimento do Titular, exceto nas
							hipóteses que impõem a EstrelaBet o resguardo dos Dados pessoais, como por exemplo,
							para o cumprimento de obrigação legal e regulatória;
						</li>
						<li>
							Informação sobre as entidades públicas e privadas com as quais houve compartilhamento
							dos dados;
						</li>
						<li>
							Informação sobre a possibilidade de não fornecer consentimento para o tratamento e as
							possíveis consequências da negativa;
						</li>
						<li>
							Revogação do consentimento a qualquer momento, por meio de procedimento gratuito e
							facilitado, sem prejuízo aos tratamentos realizados anteriormente;
						</li>
						<li>
							Revisão de decisões tomadas exclusivamente com base em tratamento automatizado de
							Dados Pessoais que afetem seus interesses, incluindo decisões de perfil pessoal,
							profissional, de consumo, de crédito ou outros aspectos de sua personalidade;
						</li>
						<li>
							Informações sobre os critérios e procedimentos usados para decisões automatizadas,
							respeitando segredos comerciais e industriais.
						</li>
					</ul>

					<p>
						Ainda, é importante enfatizar que o titular dos Dados Pessoais pode opor-se ao
						tratamento realizado com base em uma das hipóteses de dispensa de consentimento, caso
						ocorra descumprimento das disposições estabelecidas ou da legislação nacional aplicável.
					</p>

					<p>
						O prazo para atendimento das solicitações realizadas pelo titular é de 15 (quinze) dias,
						contados a partir da data do requerimento, salvo se houver prazo distinto determinado
						pela ANPD em regulamentação específica.
					</p>

					<p>
						Caso a solicitação do titular seja direcionada à EstrelaBet e esta não esteja designada
						como responsável pelo atendimento, a EstrelaBet informará ao titular o canal de
						atendimento do parceiro o qual compartilha os Dados Pessoais ou, alternativamente,
						encaminhará a solicitação o quanto antes ao parceiro, para viabilizar a resposta no
						prazo estabelecido.
					</p>

					<h3>4. POLÍTICA DE COOKIES</h3>

					<p>
						Cookies são pequenos arquivos de texto que os sites da internet armazenam no seu
						navegador quando você os visita. Eles contêm informações como suas preferências de
						idioma, login, histórico de navegação e outras configurações, e são usados pelos sites
						para melhorar sua experiência de navegação.
					</p>

					<p>
						O titular pode optar por desabilitar os cookies através das opções individuais do seu
						navegador. As informações mais detalhadas sobre o gerenciamento de cookies em
						navegadores específicos podem ser encontradas nos respectivos sites dos navegadores.
					</p>

					<h3>5. DISPOSIÇÕES FINAIS</h3>

					<p>
						A EstrelaBet se reserva o direito de modificar esta Política de Privacidade a qualquer
						momento. Sempre que houver uma alteração significativa, as novas condições entrarão em
						vigor após serem divulgadas no site da EstrelaBet ou enviadas por e-mail a você.
					</p>

					<p>
						Esta política será revisada anualmente ou sempre que houver mudança significativa dos
						processos, estrutura interna ou ambiente regulatório.
					</p>

					<p>
						Política atualizada em 12/2024
						<br />
						VERSÃO: 1.0
					</p>
				</div>
			</div>
		</div>
	);
};
export default PrivacyPolicy;
